import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import qSelectionObject from '../../hooks/qSelectionObject';
import {
    Button,
    Collapse,
    List,
    ListItem,
    makeStyles,
} from '@material-ui/core';
import clsx from 'clsx';
import { Theme } from 'utils/Theme';
import SelectionsListItem from './SelectionsListItem';

const globalTheme = Theme();

const useStyles = makeStyles((theme) => ({
    ...globalTheme,
    root: {
        backgroundColor: 'none !important',
        width: '100%',
    },
    nested: {
        paddingLeft: theme.spacing(6),
    },
}));

const QDocSelections = ({
    qDocPromise,
    cols,
    qPage,
    options,
    title,
    btnText,
    getData,
}) => {
    const { qLayout, clearSelections } = qSelectionObject({
        qDocPromise,
        cols,
        qPage,
        options,
    });
    const [open, setOpen] = useState(false);
    let selections = [];

    const handleCallback = useCallback(() => {
        return getData(qLayout, [getData, qLayout]);
    }, [getData, qLayout]);

    const handleDropDown = (clicked) => {
        setOpen(clicked === open ? null : clicked);
    };

    if (qLayout) {
        const selectedFields = qLayout.qSelectionObject.qSelections;
        if (selectedFields.length) {
            selections = selectedFields.map((value) => {
                if (value.qSelectedCount >= 1 && value.qSelectedCount <= 6) {
                    return {
                        field: value.qReadableName || value.qField,
                        selected: value.qSelectedFieldSelectionInfo.map(
                            (valueInner) => valueInner.qName
                        ),
                        total: value.qTotal,
                    };
                }
                if (value.qSelectedCount > 6) {
                    return {
                        field: value.qField,
                        selected: [
                            `${value.qSelectedCount} of ${value.qTotal}`,
                        ],
                    };
                }
                return null;
            });
        }
    }

    useEffect(() => {
        if (qLayout && getData) {
            handleCallback();
        }
    }, [getData, handleCallback, qLayout]);
    const classes = useStyles();

    return (
        <div className={clsx(classes.root)}>
            <List component={'nav'} aria-label={'Selections Menu'}>
                {selections.length > 0 && (
                    <ListItem>
                        <div className={'c-sidebar__title'}>{title}</div>
                    </ListItem>
                )}

                {selections.length >= 1 &&
                    selections.length <= 6 &&
                    selections.map((value) => {
                        if (value.selected.length === 1) {
                            return (
                                <SelectionsListItem
                                    key={value.field}
                                    field={value.field}
                                    open={open}
                                    value={`${value.field} : ${value.selected[0]}`}
                                    clearSelections={() =>
                                        clearSelections(value.field)
                                    }
                                />
                            );
                        }

                        return (
                            <span key={value.field}>
                                <SelectionsListItem
                                    clearSelections={() =>
                                        clearSelections(value.field)
                                    }
                                    open={open}
                                    hasDropdown
                                    handleDropDown={() =>
                                        handleDropDown(value.field, open)
                                    }
                                    value={`${value.field}: 
                                            ${value.selected.length} of 
                                            ${value.total}`}
                                />
                                <Collapse
                                    timeout={'auto'}
                                    unmountOnExit
                                    in={open === value.field}
                                >
                                    <List component={'div'} disablePadding>
                                        {value.selected.map(
                                            (dropdown_value) => (
                                                <SelectionsListItem
                                                    isNested
                                                    classes={classes}
                                                    open={open}
                                                    key={dropdown_value}
                                                    clearSelections={() =>
                                                        clearSelections(
                                                            value.field,
                                                            dropdown_value
                                                        )
                                                    }
                                                    value={dropdown_value}
                                                />
                                            )
                                        )}
                                    </List>
                                </Collapse>
                            </span>
                        );
                    })}
                {selections.length > 0 && (
                    <ListItem className={'u-text-center'}>
                        <Button
                            fullWidth
                            className={classes.buttonPrimary}
                            size={'small'}
                            onClick={() => clearSelections()}
                        >
                            {btnText || 'Clear All'}
                        </Button>
                    </ListItem>
                )}
            </List>
        </div>
    );
};

QDocSelections.propTypes = {
    qDocPromise: PropTypes.object.isRequired,
    cols: PropTypes.array,
    options: PropTypes.object,
    qPage: PropTypes.object,
    title: PropTypes.string,
    btnText: PropTypes.string,
    getData: PropTypes.func,
};

QDocSelections.defaultProps = {
    cols: [],
    options: { qType: 'SelectionObject' },
    qPage: {
        qTop: 0,
        qLeft: 0,
        qWidth: 1,
        qHeight: 1,
    },
    title: 'SELECTIONS',
    btnText: 'Clear All',
    getData: null,
};

export default QDocSelections;
